var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheTrigger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.19 36.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9500;}.cls-2{fill:none;stroke:#ff9500;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.09,12.64a5.07,5.07,0,0,0-4.85,4.85A5.12,5.12,0,0,0,14.63,21a2.75,2.75,0,0,1,1,2,.6.6,0,0,0,.6.6h3.64a.6.6,0,0,0,.61-.6,2.71,2.71,0,0,1,1-2,4.75,4.75,0,0,0,1.4-3.47A5,5,0,0,0,21.47,14,4.66,4.66,0,0,0,18.09,12.64Zm2.64,7.44a4.2,4.2,0,0,0-1.37,2.26H16.83a4.28,4.28,0,0,0-1.34-2.25,3.9,3.9,0,0,1-1-2.6,3.8,3.8,0,0,1,3.63-3.64,3.44,3.44,0,0,1,2.51,1,3.72,3.72,0,0,1,1.13,2.67,3.61,3.61,0,0,1-1,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.91,24.16H16.27a.61.61,0,0,0,0,1.21h3.64a.61.61,0,1,0,0-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.31,26H16.88a.61.61,0,1,0,0,1.21h2.43a.61.61,0,0,0,0-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.09,11.43a.61.61,0,0,0,.61-.61V9.61a.61.61,0,1,0-1.21,0v1.21A.61.61,0,0,0,18.09,11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.42,16.88H10.21a.61.61,0,0,0-.61.61.62.62,0,0,0,.61.61h1.21a.61.61,0,0,0,.61-.61A.61.61,0,0,0,11.42,16.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,16.88H24.76a.6.6,0,0,0-.6.61.61.61,0,0,0,.6.61H26a.61.61,0,0,0,.6-.61A.6.6,0,0,0,26,16.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.1,11.49a.6.6,0,0,0-.86,0l-.86.85a.6.6,0,0,0,0,.86h0a.6.6,0,0,0,.43.18.58.58,0,0,0,.43-.18l.86-.86A.61.61,0,0,0,24.1,11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.81,13.2a.6.6,0,0,0,0-.85h0L13,11.49a.61.61,0,0,0-.86.85l.86.86a.58.58,0,0,0,.43.18A.6.6,0,0,0,13.81,13.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 18.09,
    cy: 18.09,
    r: 17.09
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheTrigger);
export default __webpack_public_path__ + "static/media/The _trigger.9092d6ed4e6147fb903cb8843821b86a.svg";
export { ForwardRef as ReactComponent };